/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import Player from './player';

export * from './components';

/**
 * Expoting Player.
 */
export { Player };
